import { render } from "./GenerateOsList.vue?vue&type=template&id=2e69fec6&scoped=true"
import script from "./GenerateOsList.vue?vue&type=script&lang=js"
export * from "./GenerateOsList.vue?vue&type=script&lang=js"

import "./GenerateOsList.vue?vue&type=style&index=0&id=2e69fec6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e69fec6"]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QCircularProgress,QBtn});
